export enum StatusReserva {
  Reservado = 1,
  Confirmado = 2,
  Cancelado = 3
}